var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, getTestId, StateConfigContext, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { View } from 'react-native';
import { getLevelPaddings, getListWidgetStyles, levelTextColorMap, prefixAlignmentStyles } from './ListWidgetStyles';
export var ListWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ListWidget' : _props$testID,
    _props$dataArray = props.dataArray,
    dataArray = _props$dataArray === void 0 ? [] : _props$dataArray,
    typographyStyle = props.typographyStyle,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["testID", "dataArray", "typographyStyle", "onUserAction"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var ListWidgetStyles = getListWidgetStyles(props);
  if (!dataArray.length) return null;
  return _jsx(View, Object.assign({}, restProps, {
    children: dataArray === null || dataArray === void 0 ? void 0 : dataArray.map((_ref, index) => {
      var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'numbered' : _ref$type,
        iconName = _ref.iconName,
        level = _ref.level,
        _ref$iconProps = _ref.iconProps,
        iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
        _ref$noBgContainer = _ref.noBgContainer,
        noBgContainer = _ref$noBgContainer === void 0 ? true : _ref$noBgContainer,
        prefix = _ref.prefix,
        _ref$content = _ref.content,
        content = _ref$content === void 0 ? [] : _ref$content,
        _ref$accessibilityPro = _ref.accessibilityProps,
        accessibilityProps = _ref$accessibilityPro === void 0 ? {} : _ref$accessibilityPro,
        ctaTitle = _ref.ctaTitle,
        _ref$ctaProps = _ref.ctaProps,
        ctaProps = _ref$ctaProps === void 0 ? {} : _ref$ctaProps,
        onCtaPressMetaData = _ref.onCtaPressMetaData,
        style = _ref.style;
      var typographyType = level ? "body-para-" + (isLargeScreen ? 'md' : 'sm') : 'body-para-xs';
      return _jsxs(View, Object.assign({
        style: [ListWidgetStyles.container, getLevelPaddings(level, isLargeScreen), style]
      }, {
        children: [_jsxs(View, Object.assign({
          style: [prefixAlignmentStyles((prefix === null || prefix === void 0 ? void 0 : prefix.prefixAlign) || 'left', level, isLargeScreen), prefix === null || prefix === void 0 ? void 0 : prefix.style]
        }, {
          children: [type === 'icon' && _jsx(Avatar, {
            variant: type,
            size: "xxs",
            iconName: iconName,
            noBgContainer: noBgContainer,
            iconProps: iconProps,
            theme: theme
          }), type === 'bullet' && _jsx(Avatar, {
            variant: 'icon',
            size: "xxs",
            iconName: iconName,
            noBgContainer: noBgContainer,
            iconProps: iconProps,
            theme: theme
          }), type === 'numbered' && _jsx(Typography, Object.assign({}, getTestId(testID, 'prefix'), {
            color: levelTextColorMap[level],
            type: typographyType,
            style: typographyStyle
          }, prefix))]
        })), _jsxs(View, Object.assign({
          style: ListWidgetStyles.content
        }, {
          children: [_jsx(Typography, Object.assign({}, getTestId(testID, 'content'), {
            color: levelTextColorMap[level],
            type: typographyType,
            multiText: content
          }, accessibilityProps)), !!ctaTitle && _jsx(Button, Object.assign({
            title: ctaTitle,
            buttonType: "tertiary",
            style: ListWidgetStyles.ctaStyles,
            theme: theme
          }, ctaProps, {
            onPress: data => {
              var _a;
              (_a = ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.onPress) === null || _a === void 0 ? void 0 : _a.call(ctaProps, data);
              onCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onCtaPressMetaData), props));
            }
          }))]
        }))]
      }), "list_item_" + index);
    })
  }));
};
ListWidgetComponent.genericRendererKey = 'AirListWidget';